import React from 'react'
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Paper,
} from '@mui/material'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

import ProgramRequirementsList from './ProgramRequirementsList'
import ProgramVisibilityList from './ProgramVisibilityList'
import StateActionMapping from './StateActionMapping'
import ActionsList from './ActionsList'
import RewardProgramSummary from './RewardProgramSummary'

export default function ProgramOverview({ programRequirements }) {
  if (!programRequirements) return null

  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="h6">Program Overview</Typography>
      </AccordionSummary>

      <AccordionDetails>
        {/* Program Eligibility Rules */}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">Program Eligibility Rules</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box>
              <ProgramRequirementsList
                requirements={
                  programRequirements.program_eligibility_requirements
                }
              />
            </Box>
          </AccordionDetails>
        </Accordion>

        {/* Program Participation Rules */}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">Program Participation Rules</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box>
              <ProgramRequirementsList
                requirements={
                  programRequirements.program_participation_requirements
                }
              />
            </Box>
          </AccordionDetails>
        </Accordion>

        {/* Program Visibility Rules */}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">Program Visibility Rules</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box>
              <ProgramVisibilityList
                requirements={
                  programRequirements.visible_program_rules.requirements
                }
              />
            </Box>
          </AccordionDetails>
        </Accordion>

        {/* State Action Mapping */}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">
              State Action Mapping (Verification)
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box>
              <StateActionMapping
                requirements={programRequirements.actions_mapping}
              />
            </Box>
          </AccordionDetails>
        </Accordion>

        {/* Enrolled Actions */}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">Enrolled Actions</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box>
              <ActionsList
                actions={programRequirements.device_enrollment_actions}
              />
            </Box>
          </AccordionDetails>
        </Accordion>

        {/* Unenrolled Actions */}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">Unenrolled Actions</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box>
              <ActionsList
                actions={programRequirements.device_unenrollment_actions}
              />
            </Box>
          </AccordionDetails>
        </Accordion>

        {/* Reward Programs */}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">Reward Programs</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box>
              <RewardProgramSummary
                rewardPrograms={programRequirements.reward_programs}
              />
            </Box>
          </AccordionDetails>
        </Accordion>

        {/* Other Program Configurations */}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">Other Program Configurations</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box>
              <Paper variant="outlined" sx={{ p: 2, overflowX: 'auto' }}>
                <pre>
                  {JSON.stringify(
                    programRequirements.other_configuration,
                    null,
                    2,
                  )}
                </pre>
              </Paper>
            </Box>
          </AccordionDetails>
        </Accordion>

        {/* Raw Program Config */}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">Program Config (Raw JSON)</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box>
              <Paper variant="outlined" sx={{ p: 2, overflowX: 'auto' }}>
                <pre>
                  {JSON.stringify(programRequirements.program_config, null, 2)}
                </pre>
              </Paper>
            </Box>
          </AccordionDetails>
        </Accordion>
      </AccordionDetails>
    </Accordion>
  )
}
